import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=ca28f65a&scoped=true"
import script from "./Schedule.vue?vue&type=script&setup=true&lang=js"
export * from "./Schedule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=ca28f65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca28f65a",
  null
  
)

export default component.exports